import { call, put } from "redux-saga/effects";
import { Decrypt_Value } from "../EncryptDecrypt";
import { SetRefundHistory } from "../../StateManagement/Reducers/RefundState";
import { RefundList_Api } from "../Apis/RefundApi";

export function* RefundListApi() {
  try {
    console.log("reached Refund Worker");

    const res = yield call(RefundList_Api);
    if (res.status === 200) {
      console.log("Api call success for the RefundList", res.data);

      // Use the single working key 'vozo' (simplified per debug findings)
      const Decrypt_Response = Decrypt_Value(res.data, "vozo");
      console.log("Decrypted using key 'vozo'");

      const list = Array.isArray(Decrypt_Response) ? Decrypt_Response : [];
      if (!Array.isArray(Decrypt_Response)) {
        console.warn(
          "Decrypted Refund payload is not an array:",
          Decrypt_Response,
        );
      }
      console.log("sanitized data", list);

      yield put(SetRefundHistory(list));
    }
  } catch (e) {
    console.log(e.message);
    yield put(SetRefundHistory([]));
  }
}

export default RefundListApi;
